export enum ENTITY_STATUSES {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
  DELETED = "DELETED",
}
